module.exports = __webpack_public_path__ + "static/media/Web192010.9cc6a326.png";